import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { TabContainerProps } from "./PropsType";
import { getOtherProperties } from "../common/Utils";

export default function TabContainer(props: TabContainerProps) {
  const {
    children,
    className,
    index,
    prefixCls = "bm-TabContainer",
    ...other
  } = props;
  const [activeIndex, setActiveIndex] = useState(
    !!props.activeIndex && props.activeIndex > 0 ? props.activeIndex : 0
  );
  const styleClass = classNames(
    prefixCls,
    {
      [`${prefixCls}-active`]: index === activeIndex,
    },
    className
  );
  
  const otherProps = getOtherProperties(other, [
    "activeIndex",
  ]);

  useEffect(() => {
    setActiveIndex(
      !!props.activeIndex && props.activeIndex > 0 ? props.activeIndex : 0
    );
  }, [props.activeIndex]);

  return (
    <div className={styleClass} {...otherProps}>
      {children}
    </div>
  );
}

TabContainer.fnName = "TabContainer";
